import { instanceForBackend } from '../../config/axios.config';
import { BACKEND_API } from '../../constants/backendApi';
export var subscriptionService = {
    getSubscription: function () { return instanceForBackend.get(BACKEND_API.SUBSCRIPTIONS); },
    updateSubscription: function (id, data) {
        return instanceForBackend.put("".concat(BACKEND_API.SUBSCRIPTIONS, "/").concat(id), data);
    },
};
